<template>
    <div class="field mt-2">
        <label class="label">{{ $t("draw-tools.tools") }}</label>
        <div class="control">
            <div class="buttons">
                <!-- <button class="button" @click="undo">
                    <Icon name="fa-undo-alt" />
                </button>
                <button class="button" @click="redo">
                    <Icon name="fa-redo-alt" />
                </button>
                <button class="button" @click="erase">
                    <Icon name="fa-eraser" />
                </button> -->
                <button class="button" @click="clearPage">
                    <Icon name="fa-trash-alt" />
                </button>
                <button class="button" @click="sign">
                    <Icon family="fal" name="fa-signature" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "draw-tools",
    props: {
        signalRSocket: { type: Object, required: true },
    },
    mounted() {
        this.signalRSocket.on("ClearPage", this.signalRClearPage);
    },
    beforeDestroy() {
        this.signalRSocket.off("ClearPage", this.signalRClearPage);
    },
    computed: {
        ...mapGetters("colaborativeBoard", ["getPage", "getFileId"]),
        ...mapGetters("conference", ["getConferenceId", "getParticipantId"]),
    },
    methods: {
        undo() {},
        redo() {},
        erase() {},
        clearPage() {
            this.signalRSocket.invoke(
                "ClearBoard",
                this.getConferenceId,
                this.getPage,
                false
            );
        },
        sign() {
            this.signalRSocket.invoke(
                "RequireSign",
                this.getConferenceId,
                this.getParticipantId,
                this.getFileId,
                false
            );
        },
    },
};
</script>